<template>
  <div class="container">
    <h1>Une erreur s'est produite</h1>
    <img id="image_erreur" src="../assets/error.png" alt="erreur" />
    <p id="confirmation_formulaire">
      Une erreur est survenue ! Veuillez nous excuser pour la gêne occasionnée.<br />
      Pour toute demande, nous vous invitons à nous contacter au
      <a class="lien_erreur" href="tel:0372330320">03 72 33 03 20</a> ou sur
      <a class="lien_erreur" href="mailto:bonjour@reseau-colibri.fr">bonjour@reseau-colibri.fr</a>
    </p>
  </div>
</template>

<script setup></script>

<style lang="scss">
@import '../sass/app';

#image_erreur {
  width: 15%;
  display: block;
  margin: 3rem auto 3rem auto;
  @include media-breakpoint-down(sm) {
    width: 30%;
    margin: 2rem auto 2rem auto;
  }
}

#confirmation_formulaire {
  margin-top: 1rem;

  .lien_erreur {
    color: $firstcolor;
  }

  .lien_erreur:hover {
    color: $secondcolor;
    text-decoration: none;
  }
}
</style>